import { Directive, Input, OnInit } from '@angular/core';
import { FilterMatchMode, FilterService, PrimeNGConfig, SelectItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { NumericUtils } from '../utils/numeric.utils';

@Directive({
	standalone: true,
	selector: 'p-table[appCustomTableFormatedFilters], p-treeTable[appCustomTreeTableFormatedFilters]',
})
export class CustomTableFormatedFiltersDirective implements OnInit {

	@Input() formatedFiltersByName: Map<string, FormatedFilter>;
	@Input() primengTranslateKey = 'COMPONENTS.PRIMENG';

	constructor(private filterService: FilterService, private translateService: TranslateService, private primeNGConfig: PrimeNGConfig) {
	}

	ngOnInit(): void {
		if (this.formatedFiltersByName == null) {
			return;
		}

		this.getFiltersLabel()
			.subscribe(matchModesLabels => {
				// pour chaque formatteur
				this.formatedFiltersByName.forEach(formatedFilter => {
					// On clear les matchModes pour ne pas se retrouver avec des anciennes données dans le cas où la directive est rechargée avec les mêmes filtres
					formatedFilter.matchModes = [];
					// pour chaque fonction de comparaison PrimeNG du type de données
					this.primeNGConfig.filterMatchModeOptions[formatedFilter.type].forEach(matchMode => {
						// ex : nombre3DecimalesFormatter-equals, nombre3DecimalesFormatter-gte, ...
						const filterName = `${formatedFilter.name}-${matchMode}`;

						// on enregistre le filtre qui applique le formatteur sur la valeur avant d'appeller la comparaison PrimeNG
						this.filterService.register(
							filterName,
							(value, filter, filterLocale?): boolean => this.filterService.filters[matchMode](
								formatedFilter.formatter(value), formatedFilter.formatFilterValue(filter), filterLocale
							)
						);

						// on popule ensuite la map le filtre pour le rendre disponible dans les options
						formatedFilter.matchModes.push({
							label: matchModesLabels[`${this.primengTranslateKey}.${matchMode}`],
							value: filterName
						});
					});
				});
			}
		);
	}

	/**
	 * Retourne les traductions pour chaque filtre.
	 * @private
	 */
	private getFiltersLabel(): Observable<string | any> {
		const matchModes = Object.values(FilterMatchMode).map(matchMode => `${this.primengTranslateKey}.${matchMode}`);
		return this.translateService.get(matchModes);
	}

}

/**
 * Filtre formaté.
 *
 * - name : le nom du filtre
 * - type : le type des données filtrées
 * - formatter : la fonction de transformation à appliquer avant la comparaison
 * - matchModes : les options de comparaison
 */
export class FormatedFilter {
	matchModes: SelectItem[] = [];
	constructor(public name: string,
				public type: 'text' | 'numeric' | 'date',
				public formatter: Function) {
	}

	/**
	 * Formate la valeur du filtre afin de gérer les "." et les "," dans le cas des filtres numériques.
	 *
	 * @param filterValue la valeur du filtre.
	 */
	formatFilterValue<T>(filterValue: T): T | number {
		return this.type === 'numeric' ? NumericUtils.toNumericOrDefault(filterValue) : filterValue;
	}
}
